import React from 'react';
import { Link } from 'react-router-dom';
import { CCard, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CBadge } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { STATUS_COLORS, STATUS_LABELS, SENDER_TYPE_COLORS, SENDER_TYPE_LABELS, formatDateTime } from 'src/constants/supportLetters';

const urlApiletters = '/support-letters';

const SupportRequestSessionThread = ({ session, currentId, onOpenModal }) => {
	const sessionRequests = session?.requests || [];

	if (!session || sessionRequests.length === 0) return null;

	// ── Колонки: ланцюжок листів сесії ──
	const sessionRequestsColumns = [
		{ field: 'id', headerName: 'ID', width: 60 },
		{
			field: 'sender_type', headerName: 'Від', width: 70,
			renderCell: (params) => (
				<CBadge color={SENDER_TYPE_COLORS[params.row.sender_type] || 'secondary'}>
					{SENDER_TYPE_LABELS[params.row.sender_type] || params.row.sender_type || '—'}
				</CBadge>
			),
		},
		{ field: 'user_email', headerName: 'Email', width: 220 },
		{
			field: 'message', headerName: 'Повідомлення', flex: 1,
			renderCell: (params) => (
				<span title={params.row.message} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
					{params.row.message}
				</span>
			),
		},
		{
			field: 'responders', headerName: 'Команди відповідальних', width: 220, sortable: false,
			renderCell: (params) => {
				const responders = params.row.responders || [];
				if (responders.length === 0) return <span className="text-muted">—</span>;
				return (
					<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
						{responders.map(r => (
							<CBadge key={r.team_id} color="info">{r.team_name} ({r.team_code})</CBadge>
						))}
					</div>
				);
			},
		},
		{
			field: 'status', headerName: 'Статус', width: 140,
			renderCell: (params) => (
				<CBadge color={STATUS_COLORS[params.row.status] || 'secondary'}>
					{STATUS_LABELS[params.row.status] || params.row.status}
				</CBadge>
			),
		},
		{
			field: 'sent_at', headerName: 'Дата', width: 140,
			renderCell: (params) => formatDateTime(params.row.sent_at || params.row.created_at),
		},
		{
			field: 'action_modal', headerName: '👁', headerAlign: 'center', align: 'center', sortable: false, width: 50,
			renderCell: (params) => (
				<button
					className="custom-view-icon"
					title={String(params.row.id) === currentId ? 'Цей лист вже відкрито' : 'Швидкий перегляд'}
					onClick={() => onOpenModal(params.row.id)}
					disabled={String(params.row.id) === currentId}
					style={{ background: 'none', cursor: String(params.row.id) === currentId ? 'default' : 'pointer', opacity: String(params.row.id) === currentId ? 0.3 : 1 }}
				>
					👁
				</button>
			),
		},
		{
			field: 'action', headerName: '', headerAlign: 'center', align: 'center', sortable: false, width: 50,
			renderCell: (params) => (
				String(params.row.id) === currentId
					? <span className="custom-view-icon" title="Цей лист вже відкрито" style={{ opacity: 0.3 }}>🔍</span>
					: <Link to={`${urlApiletters}/view/${params.row.id}`} className="custom-view-icon" title="Переглянути лист">
						🔍
					</Link>
			),
		},
	];

	return (
		<CCard className="mb-4">
			<CAccordion activeItemKey={1}>
				<CAccordionItem itemKey={1}>
					<CAccordionHeader>
						<strong>Переписка в сесії #{session.id}{session?.subject ? ` «${session.subject}»` : ''}</strong>
					</CAccordionHeader>
					<CAccordionBody className="p-3">
						<div style={{ height: 300, width: '100%' }}>
							<DataGrid
								rows={sessionRequests}
								columns={sessionRequestsColumns}
								pageSize={10}
								rowsPerPageOptions={[10]}
								disableSelectionOnClick
								initialState={{
									sorting: { sortModel: [{ field: 'id', sort: 'asc' }] },
								}}
							/>
						</div>
					</CAccordionBody>
				</CAccordionItem>
			</CAccordion>
		</CCard>
	);
};

export default SupportRequestSessionThread;
